import { fetchContentUrl } from './payloadViaJs';

export async function fetchNativeInfo() {
  return await fetchContentUrl('native/info.js');
}

export async function downloadMetaFile(folderPath) {
  return await fetchContentUrl(`${folderPath}/meta.js`);
}
